import React from 'react';
import PropTypes from 'prop-types';

import {Chip, Divider, Stack} from '@mui/material';

import {ExpandMore} from '@mui/icons-material';

import FilterMenuPopover from './FilterMenuPopover';
import FilterOptions from './FilterOptions';

const FilterChip = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const {
    filter,
    filterSelected,
    onClick,
    onDelete,
  } = props;

  const canBeEmpty = filter.canBeEmpty;
  const multiSelect = filter.multiSelect;

  const handleClick = (filter, item) => {
    onClick(filter, item);
    setAnchorEl(null);
  };

  let label = '';
  if (multiSelect) {
    label = filterSelected.map((e) => e.label).join(', ');
  } else {
    label = filterSelected.label;
  }

  return (
    <>
      <Chip
        label={
          <Stack
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            {label}
            <ExpandMore />
            {
              !canBeEmpty &&
              <Divider orientation="vertical" variant="middle" flexItem sx={{pl: 1, my: 0.5}} />
            }
          </Stack>
        }
        onClick={(e) => setAnchorEl(e.currentTarget)}
        onDelete={canBeEmpty ? null : onDelete}
      />
      {
        anchorEl &&
        <FilterMenuPopover
          anchorEl={anchorEl}
          anchorPositionTop={anchorEl.getBoundingClientRect().bottom + 12}
          anchorPositionLeft={anchorEl.getBoundingClientRect().left}
          onClose={() => setAnchorEl(null)}
          display={<FilterOptions filter={filter} onClick={handleClick} />}
        />
      }
    </>
  );
};

FilterChip.propTypes = {
  filter: PropTypes.object.isRequired,
  filterSelected: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default React.memo(FilterChip);
